<form #docForm="ngForm" class="form-container">
  <!-- Form Header -->
  <div class="form-header">
    <div class="form-breadcrumb">
      <h3><a [routerLink]="['/doctor']">Doctors</a> > {{ doctor.name || 'Create' }}</h3>
    </div>
    <div class="form-actions">
      <button *ngIf="!isFormDisabled" [disabled]="onSaveDisable" type="submit" mat-flat-button color="primary" (click)="save(docForm.valid)">
        <mat-icon>save</mat-icon> Save
      </button>
      <button *ngIf="isFormDisabled" type="button" mat-stroked-button (click)="edit()">
        <mat-icon>edit</mat-icon> Edit
      </button>
      <button *ngIf="isFormDisabled" type="button" mat-flat-button color="primary" (click)="create()">
        <mat-icon>add</mat-icon> Create
      </button>
      <button *ngIf="!isFormDisabled" type="button" mat-stroked-button (click)="discardChanges()">
        Discard
      </button>
    </div>
  </div>

  <!-- Form Card -->
  <div class="form-card">
    <fieldset [disabled]="isFormDisabled">
      <!-- Row 1: Name, Clinic, Email -->
      <div class="row">
        <div class="col-sm-4 mb-3">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Doctor Name</mat-label>
            <input #name="ngModel" type="text" matInput name="doctor_name" [(ngModel)]="doctor.name" required>
            <mat-error *ngIf="name.invalid && name.touched">Required</mat-error>
          </mat-form-field>
        </div>
        <div class="col-sm-4 mb-3">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Clinic Name</mat-label>
            <input type="text" matInput name="clinic_name" [(ngModel)]="doctor.clinic_name">
          </mat-form-field>
        </div>
        <div class="col-sm-4 mb-3">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Email</mat-label>
            <input type="email" matInput name="email" [(ngModel)]="doctor.email">
          </mat-form-field>
        </div>
      </div>

      <!-- Row 2: Mobile, Pricelist, Sales Person -->
      <div class="row">
        <div class="col-sm-4 mb-3">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Mobile Number</mat-label>
            <input #mob="ngModel" type="number" matInput name="mobile" [(ngModel)]="doctor.mobile" required>
            <mat-error *ngIf="mob.invalid && mob.touched">Required</mat-error>
          </mat-form-field>
        </div>
        <div class="col-sm-4 mb-3">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Pricelist</mat-label>
            <mat-select #pricelist_id (openedChange)="onPriceListScroll($event)" [disabled]="isFormDisabled" [(value)]="selectedPriceList" required>
              <input class="select-input" placeholder="Search..." type="text" autocomplete="off" (keydown)="$event.stopPropagation()" (keyup)="onPriceListKey($event)" matInput name="price_list">
              <mat-option *ngFor="let pricelist of allPriceLists" [value]="pricelist.id">{{ pricelist.name }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-sm-4 mb-3">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Sales Person</mat-label>
            <mat-select #sales_person_id (openedChange)="onSalesPersonScroll($event)" [disabled]="isFormDisabled" [(value)]="selectedSalesPerson" required>
              <input class="select-input" placeholder="Search..." type="text" autocomplete="off" (keydown)="$event.stopPropagation()" (keyup)="onSalesPersonKey($event)" matInput name="sales_person_list">
              <mat-option *ngFor="let person of allSalesPerson" [value]="person.id">{{ person.name }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <!-- Row: Communication Person, Recovery Person (both optional) -->
      <div class="row">
        <div class="col-sm-4 mb-3">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Communication Person (optional)</mat-label>
            <mat-select [disabled]="isFormDisabled" [(value)]="selectedCommunicationPerson">
              <input class="select-input" placeholder="Search..." type="text" autocomplete="off" (keydown)="$event.stopPropagation()" (keyup)="onCommunicationPersonKey($event)" matInput name="communication_person_list">
              <mat-option [value]="null">-- None --</mat-option>
              <mat-option *ngFor="let person of filteredCommunicationPersons" [value]="person.id">{{ person.name }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-sm-4 mb-3">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Recovery Person (optional)</mat-label>
            <mat-select [disabled]="isFormDisabled" [(value)]="selectedRecoveryPerson">
              <input class="select-input" placeholder="Search..." type="text" autocomplete="off" (keydown)="$event.stopPropagation()" (keyup)="onRecoveryPersonKey($event)" matInput name="recovery_person_list">
              <mat-option [value]="null">-- None --</mat-option>
              <mat-option *ngFor="let person of filteredRecoveryPersons" [value]="person.id">{{ person.name }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <!-- Row 3: Address 1, Address 2, City -->
      <div class="row">
        <div class="col-sm-4 mb-3">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Address Line 1</mat-label>
            <input type="text" matInput name="address_1" [(ngModel)]="doctor.address_1">
          </mat-form-field>
        </div>
        <div class="col-sm-4 mb-3">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Area</mat-label>
            <input type="text" matInput name="address_2" [(ngModel)]="doctor.address_2">
          </mat-form-field>
        </div>
        <div class="col-sm-4 mb-3">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>City</mat-label>
            <mat-select #city_id (openedChange)="onCityScroll($event)" [disabled]="isFormDisabled" [(value)]="selectedCity" required>
              <input class="select-input" placeholder="Search..." type="text" autocomplete="off" (keydown)="$event.stopPropagation()" (keyup)="onCityKey($event)" matInput name="city_list">
              <mat-option *ngFor="let city of allCities" [value]="city.id">{{ city.name }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <!-- Row 4: State, Pincode, Company -->
      <div class="row">
        <div class="col-sm-4 mb-3">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>State</mat-label>
            <mat-select #state_id (openedChange)="onStateScroll($event)" [disabled]="isFormDisabled" [(value)]="selectedState" required>
              <input class="select-input" placeholder="Search..." type="text" autocomplete="off" (keydown)="$event.stopPropagation()" (keyup)="onStateKey($event)" matInput name="state_list">
              <mat-option *ngFor="let state of allStates" [value]="state.id">{{ state.name }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-sm-4 mb-3">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Pincode</mat-label>
            <input type="text" matInput name="pincode" [(ngModel)]="doctor.pincode">
          </mat-form-field>
        </div>
        <div class="col-sm-4 mb-3">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Company</mat-label>
            <mat-select #linked_company_id (openedChange)="OnCompanyScroll($event)" [disabled]="isFormDisabled" [(value)]="selectedCompany">
              <input class="select-input" placeholder="Search..." type="text" autocomplete="nope" (keydown)="$event.stopPropagation()" (keyup)="OnCompanyKey($event)" matInput name="company_list">
              <mat-option *ngFor="let company of allCompanies" [value]="company.id">{{ company.company_name }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <!-- Tabs Section -->
      <mat-tab-group animationDuration="0ms" class="mt-4">
        <!-- Addresses Tab -->
        <mat-tab label="Additional Addresses">
          <div class="tab-content">
            <button [disabled]="isFormDisabled" mat-flat-button (click)="openDialog(0)" color="primary" class="mb-3">
              <mat-icon>add</mat-icon> Add Address
            </button>
            <div class="table-container">
              <table #addr_table mat-table [dataSource]="addressDataSource" class="mat-elevation-z1">
                <ng-container matColumnDef="address_line_1">
                  <th mat-header-cell *matHeaderCellDef>Address</th>
                  <td mat-cell *matCellDef="let element" (click)="openDialog(element)">{{ element.address_line_1 }} {{ element.address_line_2 }}</td>
                </ng-container>
                <ng-container matColumnDef="pincode">
                  <th mat-header-cell *matHeaderCellDef>Pincode</th>
                  <td mat-cell *matCellDef="let element" (click)="openDialog(element)">{{ element.pincode }}</td>
                </ng-container>
                <ng-container matColumnDef="city">
                  <th mat-header-cell *matHeaderCellDef>City</th>
                  <td mat-cell *matCellDef="let element" (click)="openDialog(element)">{{ element.area ? element.area.name : '' }}</td>
                </ng-container>
                <ng-container matColumnDef="state">
                  <th mat-header-cell *matHeaderCellDef>State</th>
                  <td mat-cell *matCellDef="let element" (click)="openDialog(element)">{{ element.state ? element.state.name : '' }}</td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="addressDisplayedColumns"></tr>
                <tr [ngClass]="{'disableOnClick': isFormDisabled}" mat-row *matRowDef="let row; columns: addressDisplayedColumns;"></tr>
              </table>
            </div>
          </div>
        </mat-tab>

        <!-- POC Tab -->
        <mat-tab label="Additional Point of Contact">
          <div class="tab-content">
            <button [disabled]="isFormDisabled" mat-flat-button (click)="openDialogPoc(0)" color="primary" class="mb-3">
              <mat-icon>add</mat-icon> Add POC
            </button>
            <div class="table-container">
              <table #poc_table mat-table [dataSource]="pocDataSource" class="mat-elevation-z1">
                <ng-container matColumnDef="name">
                  <th mat-header-cell *matHeaderCellDef>Name</th>
                  <td mat-cell *matCellDef="let element" (click)="openDialogPoc(element)">{{ element.name }}</td>
                </ng-container>
                <ng-container matColumnDef="email">
                  <th mat-header-cell *matHeaderCellDef>Email</th>
                  <td mat-cell *matCellDef="let element" (click)="openDialogPoc(element)">{{ element.email }}</td>
                </ng-container>
                <ng-container matColumnDef="mobile">
                  <th mat-header-cell *matHeaderCellDef>Mobile</th>
                  <td mat-cell *matCellDef="let element" (click)="openDialogPoc(element)">{{ element.mobile }}</td>
                </ng-container>
                <ng-container matColumnDef="designation">
                  <th mat-header-cell *matHeaderCellDef>Designation</th>
                  <td mat-cell *matCellDef="let element" (click)="openDialogPoc(element)">{{ element.designation }}</td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="pocDisplayedColumns"></tr>
                <tr [ngClass]="{'disableOnClick': isFormDisabled}" mat-row *matRowDef="let row; columns: pocDisplayedColumns;"></tr>
              </table>
            </div>
          </div>
        </mat-tab>

        <!-- Billing Tab -->
        <mat-tab label="Billing & Taxation Details">
          <div class="tab-content">
            <div class="row">
              <div class="col-sm-4 mb-3">
                <mat-form-field appearance="fill" class="w-100">
                  <mat-label>Bill To</mat-label>
                  <input type="text" matInput name="bill_to" [(ngModel)]="doctor.bill_to">
                </mat-form-field>
              </div>
              <div class="col-sm-4 mb-3">
                <mat-form-field appearance="fill" class="w-100">
                  <mat-label>PAN</mat-label>
                  <input type="text" matInput name="pan" [(ngModel)]="doctor.pan">
                </mat-form-field>
              </div>
              <div class="col-sm-4 mb-3">
                <mat-form-field appearance="fill" class="w-100">
                  <mat-label>GST Number</mat-label>
                  <input type="text" matInput name="gst_no" [(ngModel)]="doctor.gst_no">
                </mat-form-field>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-4 mb-3">
                <mat-form-field appearance="fill" class="w-100">
                  <mat-label>Credit Limit</mat-label>
                  <input type="text" matInput name="credit_no" [(ngModel)]="doctor.credit_no">
                </mat-form-field>
              </div>
              <div class="col-sm-4 mb-3">
                <mat-form-field appearance="fill" class="w-100">
                  <mat-label>Credit Days</mat-label>
                  <input type="text" matInput name="credit_days" [(ngModel)]="doctor.credit_days">
                </mat-form-field>
              </div>
              <div class="col-sm-4 mb-3">
                <mat-form-field appearance="fill" class="w-100">
                  <mat-label>Registration Number</mat-label>
                  <input type="text" matInput name="registration_no" [(ngModel)]="doctor.registration_no">
                </mat-form-field>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12 mb-3">
                <mat-form-field appearance="fill" class="w-100">
                  <mat-label>Payment Terms & Conditions</mat-label>
                  <textarea rows="3" matInput name="payment_terms" [(ngModel)]="doctor.payment_terms"></textarea>
                </mat-form-field>
              </div>
            </div>
          </div>
        </mat-tab>
      </mat-tab-group>
    </fieldset>
  </div>
  <app-audit-log-viewer model="doctor" [recordId]="doctor.id"></app-audit-log-viewer>
</form>
